import $ from 'jquery';
window.$ = window.jQuery = $;

// comment

import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/carousel';

